import '../scrollytelling.css'
import '../v3/office.css'
import '../v4/human.css'
import './kombi.css'

import { SceneProvider, useScrollStory } from '../engine'
import { BeatsProvider } from '../v3/beats'
import { TOTAL_VH, atB, inB } from './beats'
import KombiStory from './KombiStory'

const BEATS_VALUE = { inB, atB }

/**
 * Version 5 „Kombi“: der Vorher-Nachher-Bogen aus Version 4 mit den
 * Prozess-Stationen aus Version 3. Die Panels aus v3 bekommen die
 * Zeitleiste dieser Version über `BeatsProvider`.
 */
export default function ScrollytellingV5() {
  const story = useScrollStory(1, { mode: 'pin' })

  return (
    <div ref={story.storyRef} className='sty-root off-root hum-root'>
      <section
        ref={(el) => (story.chapterRefs.current[0] = el)}
        className='off-section'
        style={{ height: `${TOTAL_VH}vh` }}
        aria-label='Finde den Menschen hinter dem Lebenslauf'
      >
        <div
          ref={(el) => (story.sceneRefs.current[0] = el)}
          className='off-sticky'
        >
          <SceneProvider index={0} subscribe={story.subscribe}>
            <BeatsProvider value={BEATS_VALUE}>
              <KombiStory />
            </BeatsProvider>
          </SceneProvider>
        </div>
      </section>
    </div>
  )
}
